import { Api } from 'models/services/api';
import { ReadRelationshipsByOwnerIdQuery } from 'models/services/graphql';

import { RelationshipCollectionData } from '../collection';

type DataToFetch = {
  ownerId: string;
  limit?: number;
  nextToken?: string;
};

const RequestQuery = `
  query ReadRelationshipsByOwnerId($ownerId: ID!, $limit: Int, $nextToken: String) {
    ${ReadRelationshipsByOwnerIdQuery}
  }
`;

type ResponseData = {
  data: {
    readRelationshipsByOwnerId: RelationshipCollectionData;
  }
}

class ReadCollectionByOwnerIdGql {

  readonly result?: RelationshipCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToFetch): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readRelationshipsByOwnerId;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionByOwnerIdGql };
